type Props = {
  className?: string;
};

export default function VerifiedIdentification({ className }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      className={className}
    >
      <path
        d="M29.5938 13.5833V4.21875C29.5938 3.73805 29.4028 3.27703 29.0629 2.93712C28.723 2.59721 28.262 2.40625 27.7812 2.40625H4.21875C3.73805 2.40625 3.27703 2.59721 2.93712 2.93712C2.59721 3.27703 2.40625 3.73805 2.40625 4.21875V20.5312C2.40625 21.012 2.59721 21.473 2.93712 21.8129C3.27703 22.1528 3.73805 22.3438 4.21875 22.3438H10.8646"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.00567 8.58792C8.00567 9.34615 8.30687 10.0733 8.84303 10.6095C9.37918 11.1456 10.1064 11.4468 10.8646 11.4468C11.6228 11.4468 12.35 11.1456 12.8861 10.6095C13.4223 10.0733 13.7235 9.34615 13.7235 8.58792C13.7235 7.82969 13.4223 7.10251 12.8861 6.56636C12.35 6.03021 11.6228 5.729 10.8646 5.729C10.1064 5.729 9.37918 6.03021 8.84303 6.56636C8.30687 7.10251 8.00567 7.82969 8.00567 8.58792Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5152 17.1649H5.96358C5.96345 16.2104 6.24204 15.2766 6.76516 14.4782C7.28828 13.6798 8.03315 13.0515 8.90833 12.6705C9.78351 12.2895 10.7509 12.1724 11.6917 12.3335C12.6325 12.4946 13.5059 12.9269 14.2044 13.5774"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.7188 6.9375H24.1562"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.7188 10.5625H25.9688"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.0938 22.3438C15.0938 24.2666 15.8576 26.1106 17.2172 27.4703C18.5769 28.8299 20.4209 29.5938 22.3438 29.5938C24.2666 29.5938 26.1106 28.8299 27.4703 27.4703C28.8299 26.1106 29.5938 24.2666 29.5938 22.3438C29.5938 20.4209 28.8299 18.5769 27.4703 17.2172C26.1106 15.8576 24.2666 15.0938 22.3438 15.0938C20.4209 15.0938 18.5769 15.8576 17.2172 17.2172C15.8576 18.5769 15.0938 20.4209 15.0938 22.3438Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.5748 20.2354L22.0646 24.9164C21.993 25.0118 21.9033 25.092 21.8007 25.1527C21.698 25.2133 21.5844 25.2532 21.4663 25.2699C21.3483 25.2866 21.2281 25.2799 21.1126 25.2501C20.9972 25.2204 20.8887 25.1682 20.7935 25.0965C20.7597 25.071 20.7278 25.0431 20.698 25.0131L18.8855 23.2006"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
